import React, { Component } from 'react';
import { connect } from 'react-redux';
import ProductElement from './ProductElement';
import SelectedProduct from './SelectedProduct';
import ErrorBoundary from '../../../ErrorBoundary';

class Products extends Component {
  constructor(props) {
    super(props);
    this.state = {
      translatePosition: 0,
      translationDistance: 200,
      maxTranslation: -2000,
      isMobile: false,
    };
    this.goLeft = this.goLeft.bind(this);
    this.goRight = this.goRight.bind(this);
    this.onResize = this.onResize.bind(this);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    const width = window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
    if (width < 768) {
      this.setState({ isMobile: true });
    } else {
      this.setState({ isMobile: false });
    }
  }

  UNSAFE_componentWillMount() {
    const width = window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
    this.setState({ isMobile: width < 768 });
    const modifier = width < 768 ? 0 : 2;
    const transD = this.state.translationDistance;
    const max = -(this.props.products.length - modifier) * transD;
    this.setState({ maxTranslation: max });
    window.addEventListener('resize', this.onResize);
  }

  goLeft() {
    this.setState(prevState => ({
      translatePosition: prevState.translatePosition - prevState.translationDistance,
    }));
  }

  goRight() {
    if ((this.state.translatePosition
      + this.state.translationDistance) > this.state.maxTranslation) {
      this.setState(prevState => ({
        translatePosition: prevState.translatePosition + prevState.translationDistance,
      }));
    }
  }

  render() {
    const productWidth = this.state.isMobile ? 200 : 150;
    const nextLeft = this.state.translatePosition - this.state.translationDistance;
    return (
      <div className="productsContainer">
        <ErrorBoundary location="teamsport" errorComponent={<p>It seems there are no products available here.</p>}>
        <div className="productGroup">
          <div className={`productSide ${this.state.translatePosition < 0 ? 'moved' : ''}`}>
            {nextLeft > this.state.maxTranslation ?
              <div className="leftNav" onClick={() => this.goLeft()} role="button" tabIndex="0" style={{ outline: 'none' }}>
                <span className="arrow" />
              </div>
              :
              null
            }
            {this.state.translatePosition < 0 ?
              <div className="rightNav" onClick={() => this.goRight()} role="button" tabIndex="0" style={{ outline: 'none' }}>
                <span className="arrow" />
              </div>
              :
              null
            }
            <div className="productGroupTitle">{this.props.productGroupTitle}</div>
              <div className="scrollHolder">
                <div
                  className="scroller"
                  style={{
                    width: `${(this.props.products.length + 5) * productWidth}px`,
                    transform: `translateX(${this.state.translatePosition}px)`,
                  }}
                >
                {this.props.products.map(product => (<ProductElement
                  key={product.id}
                  choiceID={this.props.choiceID}
                  productGroupID={this.props.productGroupID}
                  selected={this.props.selected}
                  updateSelection={this.props.updateSelection}
                  product={product}
                  productSubgroupID={this.props.productSubgroupID}
                />))}
                </div>
              </div>
          </div>
          <div className="previewSide">
            <SelectedProduct
              choiceID={this.props.choiceID}
              productGroupID={this.props.productGroupID}
              type={this.props.products.length > 0 ? this.props.products[0].type : 'default'}
              productSubgroupID={this.props.productSubgroupID}
            />
          </div>
        </div>
        </ErrorBoundary>
      </div>
    );
  }
}

const mapState = state => (
  {
    choices: state.choices,
    selection: state.selection,
  }
);

export default connect(mapState, null)(Products);
